module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('group', {
    attrs: {
      "title": "遇到问题，看看以下答案能否解答",
      "type": "hint"
    }
  }, _vm._l((_vm.helplist), function(item, index) {
    return _c('cell', {
      key: index,
      staticClass: "help",
      attrs: {
        "height": "60",
        "title": item.title
      },
      on: {
        "click": function($event) {
          return _vm.nextRoute(index)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('img', {
      staticClass: "icon",
      attrs: {
        "src": require("../assets/images/link.png"),
        "height": "12",
        "width": "7",
        "alt": ""
      }
    })])])
  }), 1), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a35908c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/help.vue
// module id = 212
// module chunks = 0